import Section from "../Section";
import Slider from '../global/Slider';

export default class Testimonial extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.sliderElement = element.querySelector('.flexslider-homepage-testimonial');

    this.slider = new Slider(theme, this.sliderElement);
    theme.testimonials = theme.testimonials || {};
    theme.testimonials[element.dataset.sliderId] = this.slider;
  }

    onBlockSelect = ({ element }) => {
      const index = parseInt(element.dataset.slideIndex, 10);
      this.slider.showSlide(index);
    }

    onBlockDeselect = () => {
      this.slider.startAnimation();
    }
}
